import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  orderEligibilitiesMockEligibleToRefund,
  orderEligibilitiesMockNotEligibleToRefund,
  orderMockEligibleToRefund,
} from '../../../mock/data/index';
import {
  servicesNotRefundableWarning,
} from '../../../mock/dictionaries/index';

/**
 * Mocks for already refunded order.
 */
export const refundConfirmationFailureMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefund)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefund, [], [servicesNotRefundableWarning])],
  cancelAndRefundOrder: [createMockDataWithResponse(orderEligibilitiesMockNotEligibleToRefund, 201)]
};
